import { schema } from 'normalizr';

const busPaxManifestPassengerSchema = new schema.Entity(
  'busPaxManifestPassenger',
  {},
  {
    idAttribute: value =>
      `${value.bookingId}-${value.pnrCode}-${value.passengerId}`,
  }
);

export default busPaxManifestPassengerSchema;
